import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Input,
  useColorModeValue,
  Button,
  Box,
  FormControl,
  Select,
  Alert,
  AlertIcon,
  useDisclosure,
} from '@chakra-ui/react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import { ViewIcon, AddIcon, Search2Icon } from '@chakra-ui/icons';
// Custom components
import { Modules, categoryMap, CspStatus } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import CustomerSavingPlanApi from 'api/customersavingplan';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';
import { isValidUUID, IdFromUrl } from 'utils/fetchUtils';
import DashboardReportApi from 'api/dashboardreport';

export default function CheckTable(props) {
  const { customerData } = props;
  const withId = props.withId;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const customerId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  const [fetchCustomerSavingPlansError, setFetchCustomerSavingPlanError] =
    useState(false);

  const { getPermissionsForModule } = usePermissions();
  const [customerSavingPlansPermissions, setCustomerSavingPlansPermissions] =
    useState(null);

  const isKycComplete = CheckKYCComplete(customerData);
  function CheckKYCComplete(customerData) {
    if (
      !customerData?.user_document ||
      !customerData.user_document.aadhar_verified ||
      !customerData.user_document.pan_verified
    ) {
      return false;
    } else {
      return true;
    }
  }
  const FetchCustomerSavingPlans = async () => {
    if (withId && !isValidUUID(customerId)) {
      setFetchCustomerSavingPlanError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await CustomerSavingPlanApi.List(
        withId
          ? {
            currentPage,
            itemsPerPage,
            searchTerm,
            categoryFilter,
            statusFilter,
            customerId,
          }
          : {
            currentPage,
            itemsPerPage,
            searchTerm,
            categoryFilter,
            statusFilter,
          }
      );
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchCustomerSavingPlanError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchCustomerSavingPlanError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchCustomerSavingPlanError(true);
      console.log(err);
      setList([]);
    }
  };

  useEffect(() => {
    const customerSavingPlansPermissions = getPermissionsForModule([
      Modules.CustomerSavingPlans,
    ]);
    setCustomerSavingPlansPermissions(customerSavingPlansPermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (customerSavingPlansPermissions?.read) {
      FetchCustomerSavingPlans();
    }
  }, [
    customerSavingPlansPermissions,
    searchTerm,
    categoryFilter,
    statusFilter,
    currentPage,
    customerId,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, categoryFilter, statusFilter]);

  useEffect(() => {
    DashboardReportApi.Notifications();
  }, []);

  const handleAddClick = () => {
    if (!isKycComplete) {
      onOpen();
    }

    window.location.href = `/admin/savingplanenroll`;
  };

  if (!customerSavingPlansPermissions?.read) {
    return <NoPermissionsMessage module={Modules.CustomerSavingPlans} />;
  }

  return fetchCustomerSavingPlansError ? (
    <PageError />
  ) : (
    <>
      <Flex mt={withId ? '0px' : '8rem'} px={withId ? '0px' : '25px'} justify='left' mb='20px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'
        ></Text>
        <Flex direction='column' gap={4} pt={withId ? 0 : 5} width='100%'>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            gap={4}
            width='100%'
            justifyContent='space-between'
          >
            <Flex>
              <Flex>
                <Input
                  variant='auth'
                  type='text'
                  minWidth='150px'
                  placeholder='Search By Account No.'
                  onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
                />
              </Flex>
              <Box ps={5}>
                <FormControl display='flex' alignItems='center'>
                  <Select
                    id='category-filter'
                    value={categoryFilter}
                    variant='auth'
                    onChange={(e) => setCategoryFilter(e.target.value)}
                  >
                    {categoryMap.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box ps={5}>
                <FormControl display='flex' alignItems='center'>
                  <Select
                    id='status-filter'
                    value={statusFilter}
                    variant='auth'
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    {CspStatus.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Flex>
            {console.log('is is with id', withId)}
            {!!withId && (
              <Flex>
                <Chakralink top='14px' right='14px'>
                  <Link
                    to={{
                      pathname: `/admin/savingplanenroll`,
                      state: customerId,
                    }}
                  >
                    <Button
                      variant='lightBrand'
                      fontSize='sm'
                      fontWeight='500'
                      borderRadius='10px'
                      boxShadow='lg'
                      px='15px'
                      py='5px'
                    >
                      <AddIcon />
                    </Button>
                  </Link>
                </Chakralink>
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
      {!isKycComplete && withId && (
        <Alert status='warning' mb={4}>
          <AlertIcon />
          Your KYC details are incomplete. Please verify your Aadhaar and PAN to
          proceed.
        </Alert>
      )}
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}
      >
        <Table variant='striped' color='gray.500' mb='24px'>
          <Thead>
            <Tr>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Account No.
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Category
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Start Date
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  End Date
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Status
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Monthly Deposit
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Amount Deposited
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Next Due Date
                </Flex>
              </Th>

              <Th pe='25px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  justifyContent='center'
                  // backgroundColor='red'
                  width='100px'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center' direction='column'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.account_number}
                      </Text>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='500'
                      >
                        ( {obj.user_name} )
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.category}-{obj.total_month} Months
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text size='sm' fontWeight='700' color={textColor}>
                        {moment(obj.start_date).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text size='sm' fontWeight='700' color={textColor}>
                        {moment(obj.end_date).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text me='10px' fontSize='sm' fontWeight='700'>
                        {
                          CspStatus.find(
                            (option) => option.value === obj?.status
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.monthly_amount}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.total_deposit_amount}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text size='sm' fontWeight='700' color={textColor}>
                        {obj.next_due_date
                          ? moment(obj.next_due_date).format('DD MMM YY')
                          : '-'}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex justify='center'>
                      {/* <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer Admin User'}
                          func={FetchCustomerSavingPlans}
                          currentUser={obj}
                        /> */}
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/myplan/${obj.id}`,
                          }}
                        >
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
}
